import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import useAnalytics from '../../../../lib/analytics/use-analytics';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

export type DownPaymentProps = RentVsBuyInput & {
  purchasePrice: string | number;
};

const DownPaymentInput: React.FC<DownPaymentProps> = ({
  value,
  purchasePrice,
  errorMessage,
  analytics,
  dispatch,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'down_payment',
        field_type: 'user_type_input',
        field_value: e.target.value,
        field: 'Down Payment',
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'downPayment',
      calculator: RENT_VS_BUY,
      inputType: 'currency',
      additionalInputIdsToValidate: ['purchasePrice'],
    });
  };

  const downPaymentLabel = (formatType?: string) => {
    const downPayment = Number(value) / Number(purchasePrice);
    if (formatType === 'percent') {
      if (!_.isFinite(downPayment)) return '-';
      return num.formatPercent(downPayment, '0%');
    }
    return num.formatCurrency(downPayment);
  };

  return (
    <InputMoney
      label={`${label} (${downPaymentLabel('percent')})`}
      value={String(value)}
      placeholder={downPaymentLabel()}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.rentvsbuyCalculator?.inputs?.downPayment,
  purchasePrice: state?.rentvsbuyCalculator?.inputs?.purchasePrice,
  errorMessage: state?.validations?.downPayment?.[0],
});

export default connect(mapStateToProps)(DownPaymentInput);
